import React from 'react';
import {Link} from 'react-router-dom';
import {scenariosData} from 'data/scenarios-data';
import Logos from 'components/ui/logos/logos';
import './select-game.scss';

const SelectGame = () => {
	
	return (
		<div className="SelectGame">
			<Logos />

			<div className="SelectGame-games">
				<div className="SelectGame-game game-1">
					<Link to={scenariosData['game1'].url} className={'SelectGame-gameBtn game1'}>
						<span>{scenariosData['game1'].title}</span>
					</Link>
				</div>
				<div className="SelectGame-game game-2">
					<Link to={scenariosData['game2'].url} className={'SelectGame-gameBtn game2'}>
						<span>{scenariosData['game2'].title}</span>
					</Link>
				</div>
			</div>
		</div>
	);
};


export default SelectGame;